<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      persistent
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title/>
      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-autocomplete
              v-model="model"
              :items="values"
              item-text="name"
              item-value="id"
              label="Select Cards"
              hide-details
              return-object
              multiple
              small-chips
              deletable-chips
          />
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
      <div
          class="resize-handle"
          @mousedown.stop.prevent="startResize"
      ></div>
    </v-card>
  </v-dialog>
</template>

<script>
import { ViewRules } from "@/common/ViewRules";
import { CardModel } from "@/modules/redactor/models/card/CardModel";
import { RedactorUtils } from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-card-dropdown-dialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: [],
    rules: ViewRules.READONLY,
    dialogWidth: 690,
    dialogHeight: 338,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 690,
    resizeStartHeight: 338,
    viewportPadding: 32
  }),
  computed: {
    values() {
      return RedactorUtils.getCards();
    }
  },
  methods: {
    show(rules, inc) {
      this.dialog = true;
      this.rules = rules;
      this.model = this.toModels(inc);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    toModels(v) {
      const arr = Array.isArray(v) ? v : (v != null ? [v] : []);
      return arr
          .map(i => {
            if (i instanceof CardModel) return i;
            if (typeof i === "string" && i.length === 32) return RedactorUtils.getCard(i);
            return null;
          })
          .filter(Boolean);
    },

    save() {
      const list = Array.isArray(this.model) ? this.model : [];
      const isValid =
          list.length > 0 &&
          list.every(i => i && typeof i.valid === "function" && i.valid());

      if (!isValid) {
        this.$alert("Invalid config!");
        return;
      }

      const ids = list.map(i => i.uid ?? i.id).filter(Boolean);

      this.resolve && this.resolve(ids);
      this.discard();
    },

    cancel() {
      this.reject && this.reject();
      this.discard();
    },

    discard() {
      this.dialog = false;
      this.stopResize();
    },

    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },

    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 400;
      const minHeight = 220;

      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;

      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },

    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>